<template>
    <div class="main">
        <div class="container mx-auto px-6 xl:px-0 pb-10">
            <div class="text-left w-full lg:w-2/3 mx-auto mt-10 terms-and-conditions">
                <SimplePageBuilder :response="response"></SimplePageBuilder>
            </div>
        </div>
    </div>
</template>
<script>
import { SimplePageBuilder } from '@freddiesflowers/frontend-component-library';
import { getButterCmsPage } from '@/helpers/ButterCmsHelpers';

export default {
    name: 'TermsAndConditions',
    components: {
        SimplePageBuilder,
    },
    data() {
        return {
            response: [],
        };
    },
    created() {
        getButterCmsPage('terms-and-conditions').then((res) => this.response = res);
    },
};
</script>

<style lang="scss">
.terms-and-conditions {
    ol {
        list-style-type: decimal;
    }
}
</style>
